import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Header from "@/components/Header.vue";
import Aside from "@/components/Aside.vue";

import "./filters"
//全局组件
Vue.component("Header", Header);
Vue.component("Aside", Aside);
// ElementUI
import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/element/element-variables.scss';
Vue.use(ElementUI);
Vue.component('el-input', {
  extends: ElementUI.Input,
  created() {
    this.$on('change', (value) => {
      this.$emit('input', value.replace(/[\u200b-\u200f\uFEFF\u202a-\u202e]/g, '').trim())
    })
  }
})

import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);

import '@/assets/css/index.scss'

Vue.config.productionTip = false;


new Vue({
  router,
  store,
  render: function (h) {
    return h(App)
  }
}).$mount('#app')